export default __webpack_public_path__ + "static/media/Flag_of_Yemen.4b3ca24e.svg";